import { render, staticRenderFns } from "./email-verification.vue?vue&type=template&id=7bed2a84&scoped=true&"
import script from "./email-verification.vue?vue&type=script&lang=ts&"
export * from "./email-verification.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bed2a84",
  null
  
)

export default component.exports